import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const links = [
  ["top", "01", "Home"],
  ["about", "02", "About"],
  ["work", "03", "Selected work"],
  ["outcomes", "04", "Outcomes"],
  ["experience", "05", "Experience"],
  ["credentials", "06", "Credentials"],
];

export default function DirectionBNav() {
  const [open, setOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("top");
  const firstLink = useRef(null);
  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== "/") {
      setActiveSection(location.pathname.startsWith("/work/") ? "work" : "top");
      return undefined;
    }

    const updateActiveSection = () => {
      const marker = window.scrollY + 180;
      let current = "top";
      links.forEach(([id]) => {
        const section = document.getElementById(id);
        if (section && section.offsetTop <= marker) current = id;
      });
      setActiveSection(current);
    };

    updateActiveSection();
    window.addEventListener("scroll", updateActiveSection, { passive: true });
    window.addEventListener("hashchange", updateActiveSection);
    window.addEventListener("resize", updateActiveSection);
    return () => {
      window.removeEventListener("scroll", updateActiveSection);
      window.removeEventListener("hashchange", updateActiveSection);
      window.removeEventListener("resize", updateActiveSection);
    };
  }, [location.pathname, location.hash]);

  useEffect(() => {
    if (!open) return undefined;
    firstLink.current?.focus();
    const onKeyDown = (event) => {
      if (event.key === "Escape") setOpen(false);
      if (event.key === "Tab") {
        const focusable = [...document.querySelectorAll(".direction-b-mobile-nav a, .direction-b-mobile-nav button")];
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [open]);

  const close = () => setOpen(false);
  return (
    <>
      <aside className="direction-b-rail" aria-label="Primary navigation">
        <Link className="direction-b-logo" to="/#top">BL</Link>
        <nav>{links.map(([id, number, label]) => <a className={activeSection === id ? "is-active" : undefined} aria-current={activeSection === id ? "location" : undefined} href={`/#${id}`} key={id}><span>{number}</span><small>{label}</small></a>)}</nav>
        <a className="direction-b-rail__linkedin" href="https://www.linkedin.com/in/brantlevinson/" target="_blank" rel="noreferrer">IN</a>
      </aside>
      <header className="direction-b-topbar">
        <Link className="direction-b-logo" to="/#top">BL</Link>
        <button type="button" className="direction-b-menu-button" aria-expanded={open} aria-controls="direction-b-mobile-nav" onClick={() => setOpen((value) => !value)}>{open ? "Close" : "Menu"}</button>
      </header>
      <div id="direction-b-mobile-nav" className={`direction-b-mobile-nav ${open ? "is-open" : ""}`} aria-hidden={!open}>
        {links.map(([id, number, label], index) => <a className={activeSection === id ? "is-active" : undefined} aria-current={activeSection === id ? "location" : undefined} href={`/#${id}`} key={id} ref={index === 0 ? firstLink : undefined} onClick={close}><span>{number}</span>{label}</a>)}
        <a href="https://www.linkedin.com/in/brantlevinson/" target="_blank" rel="noreferrer" onClick={close}>LinkedIn</a>
      </div>
    </>
  );
}
